if (!customElements.get("carousel-hero")) {
  class CarouselHero extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector(".carousel-hero__track");
      this.slides = this.querySelectorAll(".carousel-hero__slide");
      this.prevBtn = this.querySelector(".carousel-hero__nav--prev");
      this.nextBtn = this.querySelector(".carousel-hero__nav--next");
      this.dots = this.querySelectorAll(".carousel-hero__dot");

      this.currentIndex = 0;
      this.autoPlayEnabled = this.dataset.autoplay === "true";
      this.autoPlayInterval = (parseInt(this.dataset.interval) || 5) * 1000;
      this.timer = null;

      this.init();
    }

    init() {
      if (!this.track || this.slides.length === 0) return;

      // Event Listeners
      if (this.prevBtn)
        this.prevBtn.addEventListener("click", () => this.prev());
      if (this.nextBtn)
        this.nextBtn.addEventListener("click", () => this.next());

      this.dots.forEach((dot, index) => {
        dot.addEventListener("click", () => this.goToSlide(index));
      });

      // Autoplay setup
      if (this.autoPlayEnabled && this.slides.length > 1) {
        this.startAutoPlay();
        this.addEventListener("mouseenter", () => this.stopAutoPlay());
        this.addEventListener("mouseleave", () => this.startAutoPlay());
      }

      // Shopify Theme Editor Integrations
      document.addEventListener("shopify:block:select", (e) => {
        if (this.contains(e.target)) {
          const slideIndex = Array.from(this.slides).findIndex(
            (slide) => slide === e.target,
          );
          if (slideIndex > -1) this.goToSlide(slideIndex);
          this.stopAutoPlay();
        }
      });
      document.addEventListener("shopify:block:deselect", (e) => {
        if (this.contains(e.target) && this.autoPlayEnabled) {
          this.startAutoPlay();
        }
      });
    }

    goToSlide(index) {
      this.currentIndex = (index + this.slides.length) % this.slides.length;

      // Move track
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

      // Update dots
      this.dots.forEach((dot, idx) => {
        dot.classList.toggle("is-active", idx === this.currentIndex);
      });
    }

    next() {
      this.goToSlide(this.currentIndex + 1);
    }
    prev() {
      this.goToSlide(this.currentIndex - 1);
    }

    startAutoPlay() {
      this.stopAutoPlay();
      this.timer = setInterval(() => this.next(), this.autoPlayInterval);
    }

    stopAutoPlay() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  customElements.define("carousel-hero", CarouselHero);
}
